import { styled } from "@mui/material/styles";
const TranLayoutWrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    paddingTop: "10px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    paddingTop: "40px",
  },
  [theme.breakpoints.up("lg")]: {
    paddingTop: "40px",
  },
}));
const LayoutWrap = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
    margin: "0 auto",
  },
}));
const ContactMain = styled("div")(({ theme }) => ({
  width: "100%",
}));

export { TranLayoutWrapper, LayoutWrap, ContactMain };
